import React from "react";
import OrderedModuleEditor from "@/components/common/OrderedModuleEditor";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Field = ({ label, children, hint }) => (
  <div className="space-y-1">
    <Label className="text-xs text-white/50">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-white/40">{hint}</p>}
  </div>
);

export default function BlogCategories() {
  return (
    <OrderedModuleEditor
      resource="admin/site/blog-categories"
      singular="category"
      title="Blog Categories"
      subtitle="Manage categories used when creating or editing blog posts. Drag to reorder."
      titleKey="name"
      defaultValues={{ order: 1, name: "New Category", slug: "", status: "published" }}
      enableStatus
      getItemLabel={(it, idx) => it.name || `Category ${idx + 1}`}
      preparePayload={(item) => {
        const name = String(item.name || "").trim() || "Untitled Category";
        const slug = String(item.slug || name).trim().toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and");
        return {
          name,
          slug,
          order: item.order || 1,
          status: item.status === "draft" ? "draft" : "published",
        };
      }}
      renderPreviewItem={(it) => (
        <div className="flex justify-center py-3">
          <span className="inline-flex items-center justify-center px-4 py-2 rounded-full glass text-sm font-medium text-white">
            {it.name || "Untitled"}
          </span>
        </div>
      )}
      renderInspector={(item, patch) => (
        <>
          <Field label="Category name" hint="Shown on the public blog and in the post dropdown.">
            <Input
              value={item.name || ""}
              onChange={(e) => patch({ name: e.target.value })}
              className="bg-black/20 border-white/10 text-white"
              placeholder="Brand Strategy"
            />
          </Field>
          <Field label="Slug" hint="Optional URL-friendly id (auto from name if empty).">
            <Input
              value={item.slug || ""}
              onChange={(e) => patch({ slug: e.target.value })}
              className="bg-black/20 border-white/10 text-white"
              placeholder="brand-strategy"
            />
          </Field>
        </>
      )}
    />
  );
}
